export const heroData = {
  title: "RUYAN Teknoloji",
  subtitle: "Dijital Ürünler ve Yapay Zekâ ile Geleceği Şekillendiriyoruz",
  description: "Mobil uygulamalar, yapay zekâ entegrasyonu ve dijital ürünlerle uçtan uca teknoloji çözümleri sunan yeni nesil bir teknoloji şirketi.",
  backgroundImage: "https://images.unsplash.com/photo-1508361727343-ca787442dcd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc2ODM0Nzc5NXww&ixlib=rb-4.1.0&q=85"
};

export const servicesData = [
  {
    id: 1,
    title: "Dijital Ürün & Mobil Uygulama Geliştirme",
    description: "iOS & Android mobil uygulamalar, web tabanlı dijital platformlar ve ölçeklenebilir ürün mimarileri ile dijital dönüşüm sürecinizi hızlandırıyoruz.",
    features: [
      "iOS & Android mobil uygulamalar",
      "Web tabanlı dijital platformlar",
      "Abonelik, ödeme ve kullanıcı yönetimi altyapıları",
      "Ölçeklenebilir ve sürdürülebilir ürün mimarileri"
    ]
  },
  {
    id: 2,
    title: "Yapay Zekâ Entegrasyonu & İçerik Motorları",
    description: "Yapay zekâ destekli analiz ve kişiselleştirilmiş içerik motorları ile ürünlerinize akıllı özellikler kazandırıyoruz.",
    features: [
      "Yapay zekâ destekli analiz ve yorumlama sistemleri",
      "Kişiselleştirilmiş içerik ve deneyim motorları",
      "Metin, görsel ve veri üreten AI altyapıları",
      "Ürünlere entegre edilen akıllı özellikler"
    ]
  },
  {
    id: 3,
    title: "Web, Arayüz & Dijital Kimlik Sistemleri",
    description: "Kullanıcı deneyimi odaklı web siteleri ve dijital marka kimlikleri oluşturuyoruz.",
    features: [
      "Web siteleri ve ürün landing sayfaları",
      "UI/UX tasarımı ve kullanıcı deneyimi kurguları",
      "Dijital marka dili ve görsel sistemler"
    ]
  },
  {
    id: 4,
    title: "Dijital Büyüme & Görünürlük Teknolojileri",
    description: "SEO, Google Ads, Meta Ads ve performans optimizasyonu ile dijital varlığınızı büyütüyoruz.",
    features: [
      "SEO ve arama motoru görünürlüğü",
      "Google Ads reklam yönetimi",
      "Meta (Facebook & Instagram) Ads",
      "İçerik mimarisi ve yayın sistemleri",
      "Performans takibi ve büyüme optimizasyonu"
    ]
  },
  {
    id: 5,
    title: "Sosyal Medya & Marka İletişimi",
    description: "Sosyal medya yönetimi, içerik stratejisi ve marka iletişimi ile dijital varlığınızı güçlendiriyoruz.",
    features: [
      "Instagram, TikTok, LinkedIn yönetimi",
      "İçerik takvimi ve strateji planlama",
      "Influencer marketing ve işbirlikleri",
      "Sosyal medya reklam yönetimi"
    ]
  },
  {
    id: 6,
    title: "Ürün Ticarileştirme & Satış Sistemleri",
    description: "Dijital ürün satış altyapıları ve abonelik sistemleri ile gelir modellerinizi optimize ediyoruz.",
    features: [
      "Dijital ürün ve servis satış altyapıları",
      "Abonelik, kampanya ve ödeme sistemleri",
      "E-ticaret ve satış entegrasyonları"
    ]
  },
  {
    id: 7,
    title: "Medya Dağıtım & Reklam Yönetimi",
    description: "Dijital reklam altyapıları, video prodüksiyon ve AI destekli kreatif çözümler ile markanızın erişimini maksimize edin.",
    features: [
      "Google Ads, Meta Ads, TikTok ve LinkedIn reklam yönetimi",
      "Profesyonel video içerik ve animasyonlar",
      "Ürün fotoğrafçılığı ve kreatif görseller",
      "Yapay zeka destekli içerik üretimi"
    ]
  }
];

export const contactData = {
  title: "Projeniz İçin Görüşelim",
  subtitle: "Dijital dönüşüm yolculuğunuzda yanınızdayız. İletişime geçin, fikirlerinizi hayata geçirelim.",
  email: "info@ruyan.com.tr",
  phone: "+90 XXX XXX XX XX"
};
